// extracted by mini-css-extract-plugin
module.exports = {"block":"styles-module__block___ba6K6","fadeInBottom":"styles-module__fadeInBottom___xlKEg","cat":"styles-module__cat___Yk30c","link":"styles-module__link___MvIVZ"};